"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VitalSignsErrorCodeEnum = void 0;
/*
 * Any changes to this enum must be also updated in sitecore
 */
var VitalSignsErrorCodeEnum;
(function (VitalSignsErrorCodeEnum) {
    VitalSignsErrorCodeEnum["VSS001"] = "Unhandled Vitals-Service error to read patients vital signs information.";
    VitalSignsErrorCodeEnum["VSS002"] = "Error reading patients vital signs information.";
    VitalSignsErrorCodeEnum["VSS003"] = "Error downloading patients vital signs information.";
    VitalSignsErrorCodeEnum["VSS004"] = "Error transmitting patients vital signs information.";
})(VitalSignsErrorCodeEnum || (exports.VitalSignsErrorCodeEnum = VitalSignsErrorCodeEnum = {}));
//# sourceMappingURL=vital-signs-error-code.enum.js.map